// extracted by mini-css-extract-plugin
export var active = "_4g-2";
export var highlight = "_4g-1";
export var highlightLayer = "_4g-0";
export var issuePopover = "_4g-3";
export var statusIcon = "_4g-4";